export default "__VITE_ASSET__OZO_q$7C__"